import React, { memo, useCallback } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import SubmitCompanyBooking from 'Components/Front/Booking/SubmitCompanyBooking';
import AnonymousBookingForm from 'Components/Front/Booking/AnonymousBookingForm';
import NewClientBookingFlow from 'Components/Front/Booking/NewClientBookingFlow';
import CustomerBookingForm from 'Components/Front/Booking/CustomerBookingForm';
import BookingMainContent from 'Components/Front/Booking/BookingMainContent';
import BookingFormWrapper from 'Components/Front/Booking/BookingFormWrapper';
import BookingFlowStatus from 'Components/Front/Booking/BookingFlowStatus';
import BookingCartWidget from 'Components/Front/Booking/BookingCartWidget';
import WhiteLabelReturn from 'Components/Front/Booking/WhiteLabelBookingReturn';
import BookingContainer from 'Components/Front/Booking/BookingContainer';
import OAuthBookingForm from 'Components/Front/Booking/OAuthBookingForm';
import B2BFormBooking from 'Components/Front/Booking/B2BFormBooking';
import BookingSignIn from 'Components/Front/Booking/BookingSignIn';
import SubmitBooking from 'Components/Front/Booking/SubmitBooking';
import BookingModals from 'Components/Front/Booking/BookingModals';
import PreviousStep from 'Components/Front/Booking/BookingPreviousStep';
import ServicesStep from 'Components/Front/Booking/BookingServicesStep';
import BookingSteps from 'Components/Front/Booking/BookingSteps';
import PaymentForm from 'Components/Front/Booking/BookingPaymentForm';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
export default memo(function BookingComponent(props) {
  const have_services = BookingFormStore.useState(s => s.have_services);
  const token_error = BookingFormStore.useState(s => s.token_error);
  const seats_error = BookingFormStore.useState(s => s.seats_error);
  const step = BookingFormStore.useState(s => s.step);
  const is__direct = props['white-label-booking'];
  const handleGoBack = useCallback(function () {
    if (step === 0 && is__direct) {
      props.reset();
    } else if (have_services === true) {
      window.localStorage.setItem('services_picked', '');
      BookingFormStore.update(store => {
        store.step = 0;
      });
      props.stepChange?.(0);
    } else {
      props.goBack?.();
    }
  }, [have_services, props.goBack, props.stepChange, step, is__direct]);
  if (token_error) {
    const modifiers = ['booking-left'].concat(is__direct ? ['white-label-booking'] : []);
    return /*#__PURE__*/React.createElement(BookingContainer, {
      "white-label-booking": is__direct
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit('o-page-part', modifiers) + ' c-front-booking__customer'
    }, /*#__PURE__*/React.createElement(BookingFlowStatus, {
      "white-label-booking": is__direct
    })));
  } else if (seats_error && props.etablishment?.id) {
    const url = URL('FrontSpacePage').replace(':slug', props.etablishment.slug).replace(':space', props.space?.slug);
    const output = /*#__PURE__*/React.createElement("div", {
      className: bemit('c-message', ['red'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Impossible de r\xE9server 0 si\xE8ges, veuillez sp\xE9cifier le nombre de personnes.", ' ', /*#__PURE__*/React.createElement(Link, {
      href: url
    }, "Revenir \xE0 la page de r\xE9servation")));
    return output;
  }
  const steps = /*#__PURE__*/React.createElement(BookingSteps, {
    offline: props.offline,
    paid: props.paid,
    "white-label-booking": is__direct
  });
  return /*#__PURE__*/React.createElement(BookingContainer, {
    "white-label-booking": is__direct
  }, is__direct ? steps : undefined, /*#__PURE__*/React.createElement(BookingMainContent, {
    "white-label-booking": is__direct
  }, is__direct && step === 1 ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-direct-booking_header', ['white-label-booking'])
  }, /*#__PURE__*/React.createElement(WhiteLabelReturn, {
    goBack: handleGoBack
  })) : undefined, is__direct ? undefined : /*#__PURE__*/React.createElement(PreviousStep, {
    goBack: handleGoBack
  }), is__direct ? undefined : steps, /*#__PURE__*/React.createElement(BookingFormWrapper, {
    "white-label-booking": is__direct
  }, /*#__PURE__*/React.createElement(ServicesStep, {
    onStepChange: props.stepChange,
    goBack: handleGoBack,
    space: props.space,
    "white-label-booking": is__direct
  }), /*#__PURE__*/React.createElement(BookingSignIn, {
    linkedIn: true,
    google: true,
    "white-label-booking": is__direct
  }), /*#__PURE__*/React.createElement(NewClientBookingFlow, {
    etablishment: props.etablishment,
    space: props.space,
    "white-label-booking": is__direct
  }), /*#__PURE__*/React.createElement(CustomerBookingForm, {
    etablishment: props.etablishment,
    space: props.space,
    "white-label-booking": is__direct
  }), /*#__PURE__*/React.createElement(OAuthBookingForm, {
    etablishment: props.etablishment,
    space: props.space,
    "white-label-booking": is__direct
  }), /*#__PURE__*/React.createElement(AnonymousBookingForm, {
    etablishment: props.etablishment,
    space: props.space,
    "white-label-booking": is__direct
  }), /*#__PURE__*/React.createElement(PaymentForm, {
    space: props.space,
    onSuccess: props.onPaymentSuccess,
    "white-label-booking": is__direct
  }), /*#__PURE__*/React.createElement(B2BFormBooking, null))), /*#__PURE__*/React.createElement(BookingCartWidget, {
    space: props.space,
    "white-label-booking": is__direct
  }), /*#__PURE__*/React.createElement(SubmitBooking, {
    etablishment: props.etablishment,
    space: props.space,
    "white-label-booking": is__direct,
    stepChange: props.stepChange
  }), /*#__PURE__*/React.createElement(SubmitCompanyBooking, {
    etablishment: props.etablishment,
    space: props.space,
    stepChange: props.stepChange
  }), /*#__PURE__*/React.createElement(BookingModals, {
    "white-label-booking": is__direct
  }));
});
